import React from 'react';

import { StyledWrapperControl } from './style';

const WrapperControl = ({ children, className }) => (
  <StyledWrapperControl className={className}>{children}</StyledWrapperControl>
);

export default WrapperControl;
